import { Localization } from "../../../common/localizable-component";
import { DropdownLocalization } from "./dropdown-types";

export const DROPDOWN_LOCALIZATION: Localization<DropdownLocalization> = {
  en: {
    required: "This field is required.",
    selected: "selected"
  },
  de: {
    required: "Dieses Feld wird benötigt.",
    selected: "ausgewählt"
  },
  sv: {
    required: "Detta fältet är obligatoriskt.",
    selected: "utvalda"
  },
  nl: {
    required: "Dit veld is verplicht.",
    selected: "geselecteerde"
  }
};
